// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"ea00dfaaec367aeabc6d","655":"a2f80099415613a3d7ad"}[chunkId] + ".js";
};